import { html } from '@ensemble.music/ui'
import { references, referencesPlaceholder, SHOW_PROOF } from './content'

/**
 * A quiet trust strip, not a section: one low band in --primary-soft with the label on the left
 * and horizontal slots on the right. Once there are approved quotes (or venue logos) they go into
 * the same row - drop them into `references` and flip SHOW_PROOF, the layout does not change.
 *
 * Real quotes only. Until then the slots carry the occasion they are reserved for, in the muted
 * placeholder tone every other placeholder on the page uses - visible as "not filled yet", never
 * mistakable for proof.
 */
export function References() {
  const showReal = SHOW_PROOF && references.length > 0

  return (
    <html.section
      id="referenzen"
      aria-label="Referenzen"
      className="flex flex-row flex-wrap items-center justify-between gap-x-10 gap-y-5 w-full bg-primary-soft rounded-card px-8 py-6 max-sm:px-5 max-sm:py-5"
    >
      <html.div className="flex flex-col gap-1 grow shrink basis-[320px] max-w-[520px]">
        <html.p className="text-base font-semibold text-color">
          {referencesPlaceholder.label}
        </html.p>
        {showReal ? null : (
          <html.p className="text-sm text-color-tertiary">{referencesPlaceholder.note}</html.p>
        )}
      </html.div>

      {showReal ? (
        <html.div className="flex flex-row flex-wrap items-center gap-x-10 gap-y-4">
          {references.slice(0, 2).map((reference) => (
            <html.blockquote
              key={reference.person}
              className="m-0 max-w-[340px] text-base text-color-secondary"
            >
              „{reference.quote}“ – {reference.person}, {reference.occasion}
            </html.blockquote>
          ))}
        </html.div>
      ) : (
        // Logo-shaped slots, not pills: the hero's occasion pills are buttons, these must not
        // look clickable. A real logo replaces a slot one for one.
        <html.div className="flex flex-row flex-wrap items-center gap-3">
          {referencesPlaceholder.slots.map((slot) => (
            <html.span
              key={slot}
              className="inline-flex flex-row items-center justify-center w-36 h-12 rounded-xl border border-dashed border-border-color-strong text-sm text-color-tertiary"
            >
              {slot}
            </html.span>
          ))}
        </html.div>
      )}
    </html.section>
  )
}
